import { useMutation, useQuery } from "react-query";
import {
	approvePromoGiftsRequest,
	getPromoGifts,
	getPromoGiftsApprovalRequests,
} from "../services/promoGifts";

export const useGetPromoGifts = (payload) =>
	useQuery(["getPromoGifts", payload], () => getPromoGifts(payload));

export const useGetPromoGiftsApprovalRequests = (payload) =>
	useQuery(["getPromoGiftsApprovalRequests", payload], () =>
		getPromoGiftsApprovalRequests(payload)
	);

export const useApprovePromoGiftsRequest = () =>
	useMutation("approvePromoGiftsRequest", (payload) =>
		approvePromoGiftsRequest(payload)
	);
